import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    // 产品相关状态
    products: [],
    currentProduct: null,
    
    // 案例相关状态
    cases: [],
    currentCase: null,
    
    // 关于我们信息
    aboutInfo: {
      address: '',
      phone: '',
      email: '',
      introduction: '',
      history: ''
    },
    
    // 分页相关
    pagination: {
      page: 1,
      pageSize: 10,
      total: 0
    },
    
    // 加载状态
    loading: {
      products: false,
      cases: false,
      about: false
    },
    
    // 错误信息
    error: '',
    
    // 登录状态
    isLoggedIn: !!localStorage.getItem('adminToken'),
    userInfo: JSON.parse(localStorage.getItem('userInfo') || '{}')
  },
  
  mutations: {
    // 产品相关mutations
    SET_PRODUCTS(state, products) {
      state.products = products;
    },
    SET_CURRENT_PRODUCT(state, product) {
      state.currentProduct = product;
    },
    
    // 案例相关mutations
    SET_CASES(state, cases) {
      state.cases = cases;
    },
    SET_CURRENT_CASE(state, currentCase) {
      state.currentCase = currentCase;
    },
    
    // 关于我们信息mutations
    SET_ABOUT_INFO(state, info) {
      state.aboutInfo = info;
    },
    
    // 分页mutations
    SET_PAGINATION(state, pagination) {
      state.pagination = { ...state.pagination, ...pagination };
    },
    
    // 加载状态mutations
    SET_LOADING(state, { key, value }) {
      state.loading[key] = value;
    },
    
    // 错误信息mutations
    SET_ERROR(state, error) {
      state.error = error;
    },
    CLEAR_ERROR(state) {
      state.error = '';
    },
    
    // 登录状态mutations
    LOGIN_SUCCESS(state, userInfo) {
      state.isLoggedIn = true;
      state.userInfo = userInfo;
    },
    LOGOUT(state) {
      state.isLoggedIn = false;
      state.userInfo = {};
    }
  },
  
  actions: {
    
  },
  
  getters: {
    // 获取产品列表
    getProducts: state => state.products,
    
    // 获取当前产品
    getCurrentProduct: state => state.currentProduct,
    
    // 获取案例列表
    getCases: state => state.cases,
    
    // 获取当前案例
    getCurrentCase: state => state.currentCase,
    
    // 获取关于我们信息
    getAboutInfo: state => state.aboutInfo,
    
    // 获取分页信息
    getPagination: state => state.pagination,
    
    // 获取加载状态
    isProductsLoading: state => state.loading.products,
    isCasesLoading: state => state.loading.cases,
    isAboutLoading: state => state.loading.about,
    
    // 获取错误信息
    getError: state => state.error
  }
});

export default store;